module.exports = __webpack_public_path__ + "officialStatic/img/product-operation.0479e47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/product-operation.png
// module id = TRPp
// module chunks = 0